var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26729 14H15.7327C17.2391 14 18 13.2269 18 11.7427V2.25732C18 0.773054 17.2391 0 15.7327 0H2.26729C0.768574 0 0 0.765323 0 2.25732V11.7427C0 13.2347 0.768574 14 2.26729 14ZM0.953032 2.31143C0.953032 1.41469 1.42186 0.958586 2.28266 0.958586H5.67976V4.34456H0.953032V2.31143ZM6.63279 4.34456V0.958586H11.3672V4.34456H6.63279ZM15.7173 0.958586C16.5628 0.958586 17.047 1.41469 17.047 2.31143V4.34456H12.3202V0.958586H15.7173ZM0.953032 8.69685V5.30315H5.67976V8.69685H0.953032ZM6.63279 8.69685V5.30315H11.3672V8.69685H6.63279ZM12.3202 8.69685V5.30315H17.047V8.69685H12.3202ZM2.28266 13.0414C1.42186 13.0414 0.953032 12.5853 0.953032 11.6886V9.65544H5.67976V13.0414H2.28266ZM6.63279 13.0414V9.65544H11.3672V13.0414H6.63279ZM17.047 11.6886C17.047 12.5853 16.5628 13.0414 15.7173 13.0414H12.3202V9.65544H17.047V11.6886Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonth);
export default __webpack_public_path__ + "static/media/month.6293ffce5c88a848237adbc7abfbbedd.svg";
export { ForwardRef as ReactComponent };